import * as Yup from 'yup';
import { AccountAddress } from '../../../../../../shared/types/modules/account';

export const initialValues: AccountAddress = {
    city: '',
    type1: '',
    type2: '',
    number1: '',
    letter1: '',
    letter2: '',
    quadrant1: '',
    number2: '',
    letter3: '',
    letter4: '',
    quadrant2: '',
    number3: '',
    quadrant3: '',
    complement: '',
    address: '',
};

export const validationSchema = Yup.object({
    city: Yup.string().required('La ciudad es obligatoria'),
    type1: Yup.string().required('El tipo 1 es obligatorio'),
    type2: Yup.string()
        .max(20, 'El tipo 2 debe tener 20 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El tipo 2 solo debe contener caracteres alfanuméricos'
        ),
    number1: Yup.string()
        .required('El número es obligatorio')
        .max(3, 'El número debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El número solo debe contener caracteres alfanuméricos'
        ),
    letter1: Yup.string()
        .max(3, 'La letra debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'La letra solo debe contener caracteres alfanuméricos'
        ),
    letter2: Yup.string()
        .max(3, 'La letra debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'La letra solo debe contener caracteres alfanuméricos'
        ),
    quadrant1: Yup.string()
        .max(
            15,
            'El cuadrante debe tener 15 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El cuadrante solo debe contener caracteres alfanuméricos'
        ),
    number2: Yup.string()
        .required('El número es obligatorio')
        .max(3, 'El número debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El número solo debe contener caracteres alfanuméricos'
        ),
    letter3: Yup.string()
        .max(3, 'La letra debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'La letra solo debe contener caracteres alfanuméricos'
        ),
    letter4: Yup.string()
        .max(3, 'La letra debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'La letra solo debe contener caracteres alfanuméricos'
        ),
    quadrant2: Yup.string()
        .max(
            15,
            'El cuadrante debe tener 15 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El cuadrante solo debe contener caracteres alfanuméricos'
        ),
    number3: Yup.string()
        .required('El número es obligatorio')
        .max(3, 'El número debe tener 3 caracteres alfanuméricos como máximo')
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El número solo debe contener caracteres alfanuméricos'
        ),
    quadrant3: Yup.string()
        .max(
            15,
            'El cuadrante debe tener 15 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El cuadrante solo debe contener caracteres alfanuméricos'
        ),
    complement: Yup.string()
        .max(
            50,
            'El complemento debe tener 50 caracteres alfanuméricos como máximo'
        )
        .matches(
            /^[a-zA-Z0-9\s]*$/,
            'El complemento solo debe contener caracteres alfanuméricos'
        ),
    address: Yup.string().max(
        255,
        'La dirección georeferenciación debe tener 255 caracteres alfanuméricos como máximo'
    ),
});
